import React, { useState } from 'react';
import Editor from "@monaco-editor/react";
import ProctoringSystem from './ProctoringSystem';
import axios from 'axios';

import API_BASE_URL from '../../Config/config';

const CodingInterviewView = ({ userId, technology, experience }) => {
  const [interviewId, setInterviewId] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState('');
  const [code, setCode] = useState('// Write your code here\n\nfunction solution() {\n  \n}');
  const [isCompleted, setIsCompleted] = useState(false);
  const [isStarted, setIsStarted] = useState(false);
  const [warnings, setWarnings] = useState([]);
  const [apiBaseUrl] = useState(`${API_BASE_URL}/coding`);

  const startInterview = async () => {
    try {
      const response = await axios.post(`${apiBaseUrl}/start`, {
        userId, technology, experience, interviewType: 'Coding'
      });
      if (response.data.ok) {
        setInterviewId(response.data.interviewId);
        setCurrentQuestion(response.data.question);
        setIsStarted(true);
        document.documentElement.requestFullscreen();
      }
    } catch (error) {
      console.error('Failed to start interview', error);
    }
  };

  const submitCode = async () => {
    try {
      const response = await axios.post(`${apiBaseUrl}/submit`, {
        interviewId,
        answer: code,
        duration: 0 // Simplification
      });
      
      if (response.data.completed) {
        setIsCompleted(true);
      } else {
        setCurrentQuestion(response.data.question);
        // Maybe don't reset code if it's a follow-up
      }
    } catch (error) {
      console.error('Failed to submit code', error);
    }
  };

  const handleViolation = (type) => {
    setWarnings(prev => [...prev, type]);
    if (warnings.length >= 3) {
      setIsCompleted(true);
    }
  };

  if (!isStarted) {
    return (
      <div className="p-8 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl font-bold mb-4">Premium Coding Interview</h2>
        <button onClick={startInterview} className="bg-blue-600 text-white px-6 py-2 rounded-lg">Start Coding Challenge</button>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-screen bg-gray-900 text-white">
      <ProctoringSystem isActive={!isCompleted} onViolation={handleViolation} onStatusChange={()=>{}} />
      
      <div className="flex h-full">
        {/* Left Panel: Problem Statement */}
        <div className="w-1/3 p-6 overflow-y-auto border-r border-gray-700">
          <h2 className="text-xl font-bold mb-4">Problem Statement</h2>
          <div className="prose prose-invert">
            <p>{currentQuestion}</p>
          </div>
        </div>

        {/* Right Panel: Code Editor */}
        <div className="w-2/3 flex flex-col">
          <div className="flex-grow">
            <Editor
              height="100%"
              defaultLanguage="javascript"
              theme="vs-dark"
              value={code}
              onChange={(value) => setCode(value)}
              options={{
                fontSize: 14,
                minimap: { enabled: false },
                scrollBeyondLastLine: false,
              }}
            />
          </div>
          
          <div className="p-4 bg-gray-800 flex justify-end gap-4">
            <button 
              onClick={submitCode}
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-2 rounded-lg font-bold transition"
            >
              Submit Solution
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CodingInterviewView;
